import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import MinhaConta from "./views/MinhaConta.vue";
import Dashboard from "./views/Dashboard.vue";
import Dash from "./views/Dash.vue";
import Agenda from "./views/Agenda.vue";
import WhatsApp from "./views/WhatsApp.vue";
//empresas
import addEmpresa from "./views/Empresa/addEmpresa.vue";
import listEmpresa from "./views/Empresa/listEmpresa.vue";
import cfEmpresa from "./views/Empresa/cfEmpresa.vue";

//almoxarifado
import addAlmoxarifado from "./views/Almoxarifado/addAlmoxarifado.vue";
import listAlmoxarifado from "./views/Almoxarifado/listAlmoxarifado.vue";
import auditAlmoxarifado from "./views/Almoxarifado/auditAlmoxarifado.vue";

//rh
import rhRelatorios from "./views/Rh/rhRelatorios.vue";
import rhForcarAtualizacao from "./views/Rh/rhForcarAtualizacao.vue";
//RH - Colaboradores
import addColaboradores from "./views/Rh/Colaboradores/addColaboradores.vue";
import listColaboradores from "./views/Rh/Colaboradores/listColaboradores.vue";
// RH - Feriados
import addFeriados from "./views/Rh/Feriados/addFeriados.vue";
import listFeriados from "./views/Rh/Feriados/listFeriados.vue";
// RH - Justificativas
import addJustificativas from "./views/Rh/Justificativas/addJustificativas.vue";
import listJustificativas from "./views/Rh/Justificativas/listJustificativas.vue";

Vue.use(Router);

export const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/home",
      component: Home,
    },

    {
      path: "/Dashboard",
      component: Dashboard,
      children: [
        {
          path: "/Dash",
          component: Dash,
        },
        {
          path: "/MinhaConta",
          component: MinhaConta,
        },
        {
          path: "/Agenda",
          component: Agenda,
        },
        //empresas
        {
          path: "/addEmpresa",
          component: addEmpresa,
        },
        {
          path: "/listEmpresa",
          component: listEmpresa,
        },
        {
          path: "/cfEmpresa",
          component: cfEmpresa,
        },
        //Almoxarifado
        {
          path: "/addAlmoxarifado",
          component: addAlmoxarifado,
        },
        {
          path: "/listAlmoxarifado",
          component: listAlmoxarifado,
        },
        {
          path: "/auditAlmoxarifado",
          component: auditAlmoxarifado,
        },
        // RH
        {
          path: "/rhRelatorios",
          component: rhRelatorios,
        },
        {
          path: "/rhForcarAtualizacao",
          component: rhForcarAtualizacao,
        },
        // RH - Colaboradores
        {
          path: "/addColaboradores",
          component: addColaboradores,
        },
        {
          path: "/listColaboradores",
          component: listColaboradores,
        },
        // RH - FERIADOS
        {
          path: "/addFeriados",
          component: addFeriados,
        },
        {
          path: "/listFeriados",
          component: listFeriados,
        },
        // RH - Justificativas
        {
          path: "/addJustificativas",
          component: addJustificativas,
        },
        {
          path: "/listJustificativas",
          component: listJustificativas,
        },
        //whatsapp
        {
          path: "/WhatsApp",
          component: WhatsApp
        },
      ],
    },
  ],
});
